import { User } from '@core/account-types';

export enum JobKind {
  Job = 'job',
  JobTemplate = 'jobTemplate',
}

export type AutomationsJobItem = {
  id: number;
  recruiter: User | null;
  hiringManager: User | null;
  kind: JobKind;
};
